module.exports = __webpack_public_path__ + "img/stratup-brand-logo-3.decd5ef4.png";